export default template => ({
  type: 'template',
  template
});
